import React, { memo } from "react";

export const SubmitButton = memo((props) => {
  const { text, onClick, isDisabledVal } = props;

  return (
    <>
      <button 
        type="submit"
        name="testName"
        value="testValue"
        className="btn btn-primary text-white w-100"
        onClick={onClick}
        disabled={isDisabledVal}
      >
        {text}
      </button>
    </>
  );
});